import { motion } from '@eversports/react-components/design-tokens/motion'
import Button from '@eversports/react-components/primitives/Button'
import Flex from '@eversports/react-components/primitives/Flex'
import Link from '@eversports/react-components/primitives/Link'

import { useLocation } from 'react-router-dom'
import Heading from '@eversports/react-components/primitives/Heading'
import { Localized } from '../localization/react'
import getRedirectTo from '../utils/get-redirect-to'
import useIsVenueBrandingEnabled from '../hooks/useIsVenueBrandingEnabled'

const container = {
  hidden: { opacity: 0, y: 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: 'easeInOut',
      delay: 0.3,
      duration: 0.5,
    },
  },
}

const button = {
  hidden: { opacity: 0, y: 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: 'easeInOut',
      delay: 0.1,
      duration: 0.5,
    },
  },
}
const RegistrationSuccess = () => {
  const location = useLocation()
  const redirectTo = getRedirectTo(location)
  const isVenueBrandingEnabled = useIsVenueBrandingEnabled()
  return (
    <motion.div variants={container} initial="hidden" animate="visible">
      <Flex flexDirection="column" verticalSpacing="default">
        <Heading is="h1">
          <Localized id="registration-success-title" />
        </Heading>
        {!isVenueBrandingEnabled && (
          <motion.span variants={button}>
            <Link to={redirectTo} external>
              <Button fullWidth variant="primary">
                <Localized id="registration-success-title" />
              </Button>
            </Link>
          </motion.span>
        )}
      </Flex>
    </motion.div>
  )
}

export default RegistrationSuccess
